// LanguageContext.js
import React, { createContext, useContext, useState } from 'react';
import { LANGUAGES, COUNTRIES } from './config';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(
	localStorage.getItem('preferredLanguage') || 'en'
  );
  const [country, setCountry] = useState(
	localStorage.getItem('preferredCountry') || 'US'
  );

  const translate = (key, params = {}) => {
	const translation = LANGUAGES[language].translations[key];
	if (!translation) return key;

	return Object.entries(params).reduce(
	  (str, [key, value]) => str.replace(`{${key}}`, value),
	  translation
	);
  };

  const changeLanguage = (newLanguage) => {
	setLanguage(newLanguage);
	localStorage.setItem('preferredLanguage', newLanguage);
  };

  const changeCountry = (newCountry) => {
	setCountry(newCountry);
	localStorage.setItem('preferredCountry', newCountry);
	// Optionally change language to country's default
	const defaultLanguage = COUNTRIES[newCountry].defaultLanguage;
	if (defaultLanguage !== language) {
	  changeLanguage(defaultLanguage);
	}
  };

  return (
	<LanguageContext.Provider 
	  value={{ 
		language, 
		country, 
		translate, 
		changeLanguage, 
		changeCountry 
	  }}
	>
	  {children}
	</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
	throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}